import { useState } from 'react';

export default function About() {
  const [showCertificates, setShowCertificates] = useState(false);
  const [currentCertificate, setCurrentCertificate] = useState(0);

  const certificates = [
    {
      title: 'Economist-Manager',
      institution: 'Volgograd State University of Architecture and Civil Engineering',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/771bf98b61ed8c0ff57a9a8fe1dceabf.jpeg'
    },
    {
      title: 'Targeting Specialist',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/73a9f9515cf25b97c626020f4f5cb8ce.jpeg'
    },
    {
      title: 'Instagram Marketing',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/564872b9f27ac0edbf7a25ca42eb6a89.png'
    },
    {
      title: 'Pedagogy and Psychology',
      institution: 'Volgograd State Socio-Pedagogical University',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/8d50a4d864a800b7d2e79e3f72b5c3f1.png'
    },
    {
      title: 'Course Certificate',
      institution: 'Educational Institution',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/8a58d895d03b5a37da1f293318147789.png'
    },
    {
      title: 'Marketing Funnels for Business',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d5cee80e8b50569fd9a7c93173645569.png'
    },
    {
      title: 'New Certificate',
      institution: 'Educational Institution',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/a0a927a4b25daeee4f455dd61f51d863.jpeg'
    },
    {
      title: 'Specialist Certificate',
      institution: 'Educational Institution',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/704ea87e4ec70e8b3d65836a24769c4f.jpeg'
    },
    {
      title: 'Participant Certificate',
      institution: 'MBM.RU',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/c677e13c0aafbb7bcb1aa649622fa995.jpeg'
    },
    {
      title: 'Selling Taplink',
      institution: 'Taplink Academy',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e4954a02ad7b85b8fecda33979465681.jpeg'
    },
    {
      title: 'Contextual Advertising',
      institution: 'GeekBrains',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/fe86de5220bf463bbbe0541902393ca8.jpeg'
    },
    {
      title: 'BotHelp Certificate',
      institution: 'BotHelp',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/901d39f4c7ba402fc128b1f5d6c413c9.png'
    },
    {
      title: 'Tech-God Online School',
      institution: 'Tech-God Online School',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d6e65af8fb38d158caabe4fa3f2d4d80.png'
    },
    {
      title: 'Tech-God Online School (Professional)',
      institution: 'Tech-God Online School',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/4529a66dbfc2f6bd780dc254edbcbef1.png'
    },
    {
      title: 'I am Top Seller Wildberries',
      institution: 'Mercatus',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/f06124e67c84a96fed498c0e331fb07a.png'
    },
    {
      title: 'Top Ranking on Ozon',
      institution: 'Mercatus',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/28e1420f46634772fc6963739f3a4ab1.png'
    },
    {
      title: 'Reputation Management (SERM)',
      institution: 'Mercatus',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/0855821310265b01bfbb3eac74dbd03e.png'
    },
    {
      title: 'Strategic Marketing',
      institution: 'Mercatus',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/2611d623b8d7faa9ecc319920781d8ed.png'
    },
    {
      title: 'I am Seller - SberMegaMarket',
      institution: 'Mercatus',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/5575e73b7fd1950998c99fc975e1aba0.png'
    }
  ];

  const nextCertificate = () => {
    setCurrentCertificate((prev) => (prev + 1) % certificates.length);
  };

  const prevCertificate = () => {
    setCurrentCertificate((prev) => (prev - 1 + certificates.length) % certificates.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* DNA Section - Dark Background */}
        <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 rounded-3xl p-12 md:p-16 mb-16 relative overflow-hidden">
          {/* Animated Background Elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-10 left-10 w-32 h-32 bg-cyan-400 rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-400 rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-purple-400 rounded-full blur-3xl"></div>
          </div>

          {/* Neural Network Lines */}
          <div className="absolute inset-0 opacity-20">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#06b6d4', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#3b82f6', stopOpacity: 1 }} />
                </linearGradient>
              </defs>
              <line x1="10%" y1="20%" x2="90%" y2="80%" stroke="url(#lineGradient)" strokeWidth="2" />
              <line x1="20%" y1="80%" x2="80%" y2="20%" stroke="url(#lineGradient)" strokeWidth="2" />
              <line x1="50%" y1="10%" x2="50%" y2="90%" stroke="url(#lineGradient)" strokeWidth="2" />
              <circle cx="10%" cy="20%" r="8" fill="#06b6d4" />
              <circle cx="90%" cy="80%" r="8" fill="#3b82f6" />
              <circle cx="20%" cy="80%" r="8" fill="#06b6d4" />
              <circle cx="80%" cy="20%" r="8" fill="#3b82f6" />
              <circle cx="50%" cy="10%" r="8" fill="#06b6d4" />
              <circle cx="50%" cy="90%" r="8" fill="#3b82f6" />
            </svg>
          </div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <div className="inline-block bg-cyan-500/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
                <span className="text-cyan-300 font-bold text-lg">🧬 About Us</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Evolution from Top Expert to Founder
              </h2>
              <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
                We don't believe in intuitive marketing. We believe in data precision, deep psychology, and algorithm speed. Our company is a symbiosis of academic education, rigorous practice in leading agencies, and cutting-edge technology.
              </p>
            </div>
          </div>
        </div>

        {/* Founder Section - Light Background */}
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-12 md:p-16 mb-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Photo */}
            <div className="order-2 lg:order-1">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl blur-2xl opacity-20"></div>
                <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl">
                  <img 
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/b5a83a46aaca1163ce20a0c491f11d56.jpeg"
                    alt="Irina Sharova-Yalynpala - Founder and Ideologist"
                    className="w-full h-auto object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-blue-600 text-white px-6 py-3 rounded-full mb-6">
                <span className="font-bold text-lg">👩‍💼 Founder and Ideologist</span>
              </div>
              <h3 className="text-4xl font-bold text-slate-900 mb-4">
                Irina Sharova-Yalynpala
              </h3>
              <p className="text-lg text-blue-600 font-semibold mb-6">
                Agency Founder, Marketing Director, Systematic Growth Expert
              </p>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                My journey is not a random success, but a natural result of continuous learning and working at the market forefront.
              </p>

              {/* Quote */}
              <div className="bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl p-6 text-white mb-8">
                <i className="ri-double-quotes-l text-4xl opacity-50 mb-2"></i>
                <p className="text-lg font-medium leading-relaxed">
                  My goal is to transform your marketing from a 'black hole' for budget into a managed asset that generates profit 24/7.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Journey Timeline */}
        <div className="bg-white rounded-3xl p-12 md:p-16 shadow-xl mb-16">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-slate-900 mb-6">
              🚀 From Top Student to Own Business
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Journey from academic education through work at a top agency to creating my own company
            </p>
          </div>

          {/* Timeline Steps */}
          <div className="space-y-8">
            {/* Step 1 */}
            <div className="relative pl-8 border-l-4 border-purple-500">
              <div className="absolute -left-3 top-0 w-6 h-6 bg-purple-500 rounded-full"></div>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border-2 border-purple-200">
                <h4 className="text-2xl font-bold text-slate-900 mb-3">
                  📚 Fundamental Start
                </h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  I entered the profession with two higher education degrees: <strong className="text-purple-600">Pedagogy and Psychology</strong> (understanding people) + <strong className="text-purple-600">Economics and Management</strong> (understanding money). Mastered Digital Marketing from scratch at the top center Convert Monster, progressing from copywriter to strategist.
                </p>
                <div className="bg-white rounded-xl p-4 border-l-4 border-purple-500">
                  <p className="text-purple-700 font-semibold">
                    ✓ Result: Recognized as the best student of the stream and received a personal invitation to work on staff at Convert Monster agency.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative pl-8 border-l-4 border-blue-500">
              <div className="absolute -left-3 top-0 w-6 h-6 bg-blue-500 rounded-full"></div>
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border-2 border-blue-200">
                <h4 className="text-2xl font-bold text-slate-900 mb-3">
                  💼 Field Results
                </h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Working in the traffic department, I managed budgets up to <strong className="text-blue-600">1,000,000 ₽/month</strong> (real estate) and worked with dozens of niches: from house construction to hotels.
                </p>
                <div className="bg-white rounded-xl p-4 border-l-4 border-blue-500">
                  <p className="text-blue-700 font-semibold">
                    ✓ Result: In 2021, the traffic department with my participation increased the agency's profit by 150%. I proved in practice that I can scale other people's businesses.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative pl-8 border-l-4 border-green-500">
              <div className="absolute -left-3 top-0 w-6 h-6 bg-green-500 rounded-full"></div>
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
                <h4 className="text-2xl font-bold text-slate-900 mb-3">
                  🏆 Logical Peak — My Own Company
                </h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Accumulated expertise, ability to build strategies and take responsibility for client money allowed me to take the position of <strong className="text-green-600">Marketing Director</strong>. But I saw that the market needs more than standard solutions.
                </p>
                <div className="bg-white rounded-xl p-4 border-l-4 border-green-500">
                  <p className="text-green-700 font-semibold">
                    ✓ That's why I founded my own company. Here I implement my vision: combining systematic marketing with Artificial Intelligence technologies to give clients predictable growth without 'draining' the budget.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* AI Philosophy Section */}
        <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 rounded-3xl p-12 md:p-16 mb-16 relative overflow-hidden">
          {/* Animated Background */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-10 right-10 w-40 h-40 bg-purple-400 rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-48 h-48 bg-cyan-400 rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <div className="text-center mb-10">
              <div className="inline-block bg-purple-500/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
                <span className="text-purple-300 font-bold text-lg">🤖 AI Philosophy</span>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Why is AI at the Core of the Company?
              </h3>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                In my list of professional skills, there has always been a point: "Ability to analyze large volumes of data." Previously, this took weeks. Now, as a founder, I have implemented Artificial Intelligence in all agency processes.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-speed-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Speed Up Routine</h4>
                    <p className="text-gray-300">
                      What a human does in 40 hours, our algorithms do in 40 minutes.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Eliminate Errors</h4>
                    <p className="text-gray-300">
                      The machine sees non-obvious connections in statistics that even an experienced marketer's eye might miss.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Reduce Lead Cost</h4>
                    <p className="text-gray-300">
                      We find the cheapest and most effective combinations faster than competitors.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Predictable Growth</h4>
                    <p className="text-gray-300">
                      Every step is calculated by machine and verified by expert for maximum efficiency.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hard Skills Section */}
        <div className="bg-white rounded-3xl p-12 md:p-16 shadow-xl mb-16">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-slate-900 mb-6">
              🛠 Key Competencies (Hard Skills)
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              My team and I cover the full spectrum of Digital Marketing tasks
            </p>
          </div>

          {/* Hard Skills Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border-2 border-purple-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Strategy and Management</h4>
                  <p className="text-gray-700">
                    Competitive analysis, Media planning, Unit economics, contractor team management.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border-2 border-blue-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-advertisement-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">All Paid Traffic</h4>
                  <p className="text-gray-700">
                    Professional setup of Yandex.Direct (Search, RSA), Google Ads and targeted advertising (Instagram, Facebook, VK, MyTarget).
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-shopping-cart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Marketplaces</h4>
                  <p className="text-gray-700">
                    Top ranking and sales scaling on Ozon and Wildberries.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl p-6 border-2 border-orange-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-bar-chart-box-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Analytics</h4>
                  <p className="text-gray-700">
                    End-to-end analytics, Google Analytics, Yandex.Metrica. Decision-making based only on numbers (Data Driven).
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Certificates Button */}
          <div className="text-center">
            <button
              onClick={() => setShowCertificates(!showCertificates)}
              className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-8 py-4 rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-award-line text-2xl mr-2"></i>
              {showCertificates ? 'Hide Diplomas and Certificates' : 'View Diplomas and Certificates'}
            </button>
          </div>

          {/* Certificates Carousel */}
          {showCertificates && (
            <div className="mt-12 animate-fadeIn">
              <div className="relative bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8">
                {/* Certificate Display */}
                <div className="mb-6">
                  <div className="bg-white rounded-xl overflow-hidden shadow-lg">
                    <img 
                      src={certificates[currentCertificate].image}
                      alt={certificates[currentCertificate].title}
                      className="w-full h-auto object-contain"
                    />
                  </div>
                </div>

                {/* Navigation */}
                <div className="flex items-center justify-center gap-4">
                  <button
                    onClick={prevCertificate}
                    className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-arrow-left-s-line text-2xl text-slate-900"></i>
                  </button>
                  
                  <div className="flex gap-2">
                    {certificates.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentCertificate(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                          index === currentCertificate 
                            ? 'bg-blue-500 w-8' 
                            : 'bg-gray-300 hover:bg-gray-400'
                        }`}
                      ></button>
                    ))}
                  </div>

                  <button
                    onClick={nextCertificate}
                    className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-2xl text-slate-900"></i>
                  </button>
                </div>

                {/* Counter */}
                <div className="text-center mt-4">
                  <p className="text-gray-600">
                    {currentCertificate + 1} / {certificates.length}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Team Section */}
        <div id="team" className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-3xl p-12 md:p-16">
          <div className="text-center mb-12">
            <div className="inline-block bg-cyan-500/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
              <span className="text-cyan-300 font-bold text-lg">👥 Team</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Experts Working on Your Success
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Each member of our team is a specialist with proven expertise in their field
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Team Member 1 - Alexander */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden border border-white/20 hover:border-cyan-400 transition-all duration-300">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/93aaf5020092a3320ab0f29c3cbea8a7.jpeg"
                  alt="Alexander - Head of Traffic Department"
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Alexander</h3>
                <p className="text-cyan-300 font-medium mb-3">Head of Traffic Department</p>
                <div className="text-gray-300 text-sm space-y-1">
                  <p className="font-semibold text-white mb-2">Team Members:</p>
                  <p>• Targeting Specialist</p>
                  <p>• Contextual/Direct Specialist</p>
                  <p>• Seeding and Influencer Specialist</p>
                  <p>• Traffic Managers</p>
                </div>
              </div>
            </div>

            {/* Team Member 2 - Maria */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden border border-white/20 hover:border-cyan-400 transition-all duration-300">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d8d06fbe10a6be3269432b6fb540e762.jpg"
                  alt="Maria - Head of Internet Marketers"
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Maria</h3>
                <p className="text-cyan-300 font-medium mb-3">Head of Internet Marketers</p>
                <div className="text-gray-300 text-sm space-y-1">
                  <p className="font-semibold text-white mb-2">Team Members:</p>
                  <p>• Copywriter</p>
                  <p>• Designer</p>
                  <p>• SEO Specialist</p>
                  <p>• CRM Marketer</p>
                  <p>• Marketing Assistant</p>
                </div>
              </div>
            </div>

            {/* Team Member 3 - Svyatoslav */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden border border-white/20 hover:border-cyan-400 transition-all duration-300">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/9e9ba90b3be482d952c0034700e7ab93.png" 
                  alt="Svyatoslav - Head of Marketplace Marketing"
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Svyatoslav</h3>
                <p className="text-cyan-300 font-medium mb-3">Head of Marketplace Marketing</p>
                <div className="text-gray-300 text-sm space-y-1">
                  <p className="font-semibold text-white mb-2">Team Members:</p>
                  <p>• Analyst</p>
                  <p>• Marketplace Manager</p>
                  <p>• SEO Analyst</p>
                  <p>• Designer</p>
                  <p>• Logistics Specialist</p>
                </div>
              </div>
            </div>

            {/* Team Member 4 - Dmitry */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden border border-white/20 hover:border-cyan-400 transition-all duration-300">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/604fab24ed9ff7e22872b0f16f786d71.jpeg"
                  alt="Dmitry - IT Director"
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Dmitry</h3>
                <p className="text-cyan-300 font-medium mb-3">IT Director</p>
                <div className="text-gray-300 text-sm space-y-1">
                  <p className="font-semibold text-white mb-2">Team Members:</p>
                  <p>• Prompt Engineer</p>
                  <p>• Data Scientist</p>
                  <p>• AI Project Manager</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}